<div>
  <div class="logo-wrapper" routerLink="/">
    <img src="assets/images/logo.svg" class="custom-logo" alt="Gesundheit in Bewegung">
  </div>
  <sidenav-tree *ngFor="let treeElement of treeElements" [treeContent]="treeElement"></sidenav-tree>
</div>
